var map = {
	"./de.png": 951,
	"./en.png": 952,
	"./es.png": 953,
	"./fr.png": 954,
	"./ja.png": 955,
	"./mk.png": 956,
	"./pt.png": 957,
	"./tr.png": 958,
	"./zh.png": 959
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 950;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 950
// module chunks = 0